import type {Theme} from '@mui/material';
import {hapTheme} from 'presentation/themes/hap.styles';
import {infinityTheme} from 'presentation/themes/infinity.styles';
import {advanceTheme} from 'presentation/themes/advance.styles';
import {create} from 'zustand';
import {notredameSaudeTheme} from 'presentation/themes/notredameSaude.styles';
import {premiumTheme} from 'presentation/themes/premium.styles';
import {ProductEnum} from 'presentation/constants';

const THEME: Record<string, Theme> = {
	hap: hapTheme,
	infinity: infinityTheme,
	advance: advanceTheme,
	premium: premiumTheme,
	notredame: notredameSaudeTheme,
};

export type ThemeNameType = 'hap' | 'infinity' | 'advance' | 'notredame' | string;

type ThemeStore = {
	theme: Theme;
	setTheme: (theme: ThemeNameType) => void;
	resetTheme: () => void;
};

const getInitialTheme = (): Theme => {
	const hostname = window.location.hostname.replace(/^www\./, '');
	if (hostname.includes(ProductEnum.NOTREDAME_SAUDE)) return notredameSaudeTheme;

	return hapTheme;
};

export const useThemeStore = create<ThemeStore>(set => ({
	theme: getInitialTheme(),
	setTheme: (theme: ThemeNameType) => {
		if (theme in THEME) {
			set({theme: THEME[theme]});
		} else {
			set({theme: THEME.hap});
		}
	},
	resetTheme: () => {
		set({theme: getInitialTheme()});
	},
}));
